/**
 * KHIYARSA (AI): main-menu entry for Create-with-AI. Captures the current
 * text selection at open time so the dialog can offer it as source material
 * (never sent unless the user leaves the checkbox on AND presses Generate).
 */
import { MainMenu } from "@excalidraw/excalidraw/index";
import { useApp } from "@excalidraw/excalidraw/components/App";
import { brainIcon } from "@excalidraw/excalidraw/components/icons";
import React from "react";

import { useSetAtom } from "../../app-jotai";

import { aiDialogAtom } from "./atoms";
import { useAiT } from "./strings";

interface SelectionSource {
  state: { selectedElementIds: Readonly<Record<string, boolean>> };
  scene: {
    getNonDeletedElements: () => readonly { id: string; type: string }[];
  };
}

export const collectSelectedText = (app: SelectionSource): string => {
  const selected = app.state.selectedElementIds;
  return app.scene
    .getNonDeletedElements()
    .filter((el) => selected[el.id] && el.type === "text")
    .map((el) => (el as unknown as { text: string }).text)
    .join("\n\n")
    .trim();
};

export const AiMenuItems = () => {
  const t = useAiT();
  const app = useApp();
  const setDialog = useSetAtom(aiDialogAtom);

  return (
    <MainMenu.Item
      icon={brainIcon}
      onSelect={() => {
        const sourceMaterial = collectSelectedText(app);
        setDialog({
          open: true,
          sourceMaterial: sourceMaterial || undefined,
        });
      }}
    >
      {t("createWithAi")}
    </MainMenu.Item>
  );
};
